import { render, staticRenderFns } from "./EventCalendar.vue?vue&type=template&id=87d3573e&"
import script from "./EventCalendar.vue?vue&type=script&lang=js&"
export * from "./EventCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports